module.exports = __webpack_public_path__ + "img/horizontal-active.d6658635.svg";